export const CIC_REASON_MODAL_CONTROLS_ID = 'cic-reason-modal-controls';

export const NOTE_MAX_LENGTH = 500;
